import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import renderSelectField from '../../../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../../../shared/components/form/MultiSelect';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Card } from 'reactstrap';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);
renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class Habits extends Component {
    constructor() {
        super();
        this.state = {
            firewood: "",
            smoke: "",
            comsuption: "",
            alcohol: "",
            physicalActivity: "",
            total: 0
        }
    }

    handlerPackegesPerYear = (packegesPerYear) => {
        this.setState({ packegesPerYear: packegesPerYear })
    }

    handlersYearsExpose = (years) => {
        this.setState({ years: years })
    }

    handlerSelectFirewood = (firewood) => {
        console.log(firewood);
        this.setState({ firewood: firewood })
    }

    handlerSelectSmoke = (smoke) => {
        console.log(smoke);
        this.setState({ smoke: smoke })
    }

    handlerPsychoactiveSubstances = (comsuption) => {
        console.log(comsuption);
        this.setState({ comsuption: comsuption })
    }

    handlerFrecuencyOfConsumption = (frecuency) => {
        this.setState({ frecuency: frecuency });
    }

    handlerSubstance = (substance) => {
        this.setState({ substance: substance });
    }

    handlerAlcoholConsumption = (alcohol) => {
        this.setState({ alcohol: alcohol });
    }

    handlerAlcoholConsumptionLastYear = (alcoholLastYear) => {
        this.setState({ alcoholLastYear: alcoholLastYear });
    }

    handlerFrecuencyOfConsumptionAlcohol = (frecuencyAlcohol) => {
        this.setState({ frecuencyAlcohol: frecuencyAlcohol });
    }

    handlerPhysicalActivity = (physicalActivity) => {
        this.setState({ physicalActivity: physicalActivity });
    }

    handlerFrecuencyPhysicalActivity = (frecuencyPhysicalActivity) => {
        this.setState({ frecuencyPhysicalActivity: frecuencyPhysicalActivity });
    }

    handlerWhatActivies = (activities) => {
        this.setState({ activities: activities });
    }

    render() {
        return (
            <Card>
                <Col>
                    <div>
                        <div className="half">
                            <div className="form">
                                <div style={{ width: "10%" }}>
                                    <div className="card__title">
                                        <h5 className="bold-text">Información de tabaco</h5>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Fumador</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                className="smoke"
                                                name="select-smoke"
                                                component={renderSelectField}
                                                options={[
                                                    { value: "No", label: "No" },
                                                    { value: "Exfumador", label: "Exfumador" },
                                                    { value: "Actual", label: "Actual" },

                                                ]}
                                                value={this.props.habits.smoke}
                                                onChange={(e) => {
                                                    console.log(e)
                                                    this.props.handlerHabits("smoke", e);
                                                    this.setState({ smoke: e });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {this.props.habits.smoke.value === "Actual" || this.props.habits.smoke.value === "Exfumador" ? (
                                    <Fragment>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "10%", marginTop: 70, marginLeft: 15 }}
                                        >
                                            <span className="form__form-group-label">
                                                Cigarrillos / día
                                            </span>
                                            <div className="form__form-group-field">
                                                <input
                                                    name="CigarretsPerDay"
                                                    placeholder=""
                                                    type="number"
                                                    //value={this.props.habits.packegesPerYear}
                                                    onChange={(e) => {
                                                        this.setState({ total: e.target.value });
                                                        this.props.handlerHabits("CigarretsPerDay", e.target.value);
                                                        this.props.handlerHabits("PackegesPerYear", (e.target.value * 365) / 20);
                                                    }}
                                                    disabled={false}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "10%", marginTop: 70, marginLeft: 15 }}
                                        >
                                            <span className="form__form-group-label">
                                                Paquetes / Año
                                            </span>
                                            <div className="form__form-group-field">
                                                <input
                                                    name="PackegesPerYear"
                                                    placeholder=""
                                                    type="number"
                                                    value={(this.state.total * 365) / 20}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "10%", marginTop: 70, marginLeft: 15 }}
                                        >
                                            <span className="form__form-group-label">
                                                Año Inicio de Consumo
                                            </span>
                                            <div className="form__form-group-field">
                                                <input
                                                    name="YearofStart"
                                                    placeholder=""
                                                    type="text"
                                                    maxLength={4}
                                                    onChange={(e) => {
                                                        this.props.handlerHabits("YearofStart", e.target.value);
                                                    }}

                                                />
                                            </div>
                                        </div>
                                    </Fragment>
                                ) : null}

                                {this.props.habits.smoke.value === "Exfumador" ?
                                    <div
                                        className="form__form-group"
                                        style={{ width: "10%", marginTop: 70, marginLeft: 15 }}
                                    >
                                        <span className="form__form-group-label">
                                            Año Fin de Consumo
                                        </span>
                                        <div className="form__form-group-field">
                                            <input
                                                name="YearofEnd"
                                                placeholder=""
                                                type="text"
                                                maxLength={4}
                                                onChange={(e) => {
                                                    this.props.handlerHabits("YearofEnd", e.target.value);
                                                }}

                                            />
                                        </div>
                                    </div> : null}

                                <div
                                    className="form__form-group"
                                    style={{ width: "10%", marginTop: 65, marginLeft: 15 }}
                                >
                                    <span className="form__form-group-label">
                                        Exposición humo de leña
                                    </span>
                                    <div className="lumber-form__form-group-field">
                                        <Field
                                            className="years-select"
                                            name="select-firewood"
                                            component={renderSelectField}
                                            options={[
                                                { value: "Si", label: "Si" },
                                                { value: "No", label: "No" },
                                            ]}
                                            value={this.props.habits.firewood}
                                            onChange={(e) => {
                                                console.log(e);
                                                this.props.handlerHabits("firewood", e);
                                                this.setState({ firewood: e });
                                            }}
                                        />
                                    </div>
                                </div>
                                {this.props.habits.firewood.value === "Si" ? (
                                    <Fragment>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "10%", marginTop: 70, marginLeft: 15 }}
                                        >
                                            <span className="form__form-group-label">
                                                Años exposición
                                            </span>
                                            <div className="years-form__form-group-field">
                                                <Field
                                                    className="years-form"
                                                    name="yearsExpose"
                                                    component={renderField}
                                                    type="number"
                                                    placeholder="número de años"
                                                    value={this.props.habits.years}
                                                    onChange={(e) =>
                                                        this.props.handlerHabits("years", e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Fragment>
                                ) : null}
                            </div>
                            <div className="form">
                                <div className="card__title">
                                    <h5 className="bold-text">
                                        Información de sustancias psicoactivas
                                    </h5>
                                </div>
                                <div className="form__form-group">
                                    <span className="form__form-group-label">
                                        Consumo de sustancias psicoactivas
                                    </span>
                                    <div className="lumber-form__form-group-field"
                                        style={{ width: "20%" }}
                                    >
                                        <label className="radio-btn" >
                                            <input
                                                className="radio-btn__radio"
                                                name="comsuption"
                                                type="radio"
                                                value={'Si'}
                                                checked={this.props.habits.comsuption === 'Si'}
                                                onChange={(e) => {
                                                    this.props.handlerHabits("comsuption", e.target.value);
                                                    this.setState({ comsuption: e.target.value });
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Sí"}</span>
                                        </label>
                                        <label className="radio-btn" >

                                            <input
                                                className="radio-btn__radio"
                                                name="comsuption"
                                                type="radio"
                                                value={'No'}
                                                checked={this.props.habits.comsuption === 'No'}
                                                onChange={(e) => {
                                                    console.log(e.target.value)
                                                    this.props.handlerHabits("comsuption", e.target.value);
                                                    this.setState({ comsuption: e.target.value });
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"No"}</span>
                                        </label>
                                    </div>
                                </div>
                                {this.props.habits.comsuption === "Si" ? (
                                    <>
                                        <div className="form__form-group" style={{ width: "10%" }}>
                                            <span className="form__form-group-label">Frecuencia</span>
                                            <div className="lumber-form__form-group-field">
                                                <Field
                                                    className="years-select"
                                                    name="frecuency-of-consumption"
                                                    component={renderSelectField}
                                                    options={[
                                                        { value: "Diaria", label: "Diaria" },
                                                        { value: "Semanal", label: "Semanal" },
                                                        { value: "Mensual", label: "Mensual" },
                                                    ]}
                                                    value={this.props.habits.frecuency}
                                                    onChange={(e) =>
                                                        this.props.handlerHabits("frecuency", e)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "40%", marginLeft: 15 }}
                                        >
                                            <span className="form__form-group-label">Sustancias</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="multiSelect-subtances"
                                                    component={renderMultiSelectField}
                                                    options={[
                                                        { value: "Cocaina", label: "Cocaina" },
                                                        { value: "Bazuco", label: "Bazuco" },
                                                        { value: "Extasis", label: "Extasis" },
                                                        { value: "Heroina", label: "Heroina" },
                                                        { value: "LSD", label: "LSD" },
                                                        { value: "Hongos", label: "Hongos" },
                                                        { value: "Marihuana", label: "Marihuana" },
                                                        { value: "GHB", label: "GHB" },
                                                    ]}
                                                    value={this.props.habits.substaces}
                                                    onChange={(e) => {
                                                        console.log(e);
                                                        this.props.handlerHabits("substaces", e);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "30%", marginLeft: 15 }}
                                        >
                                            <span className="form__form-group-label">
                                                Otras Sustancias
                                            </span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="another-substance"
                                                    component={renderField}
                                                    type="text"
                                                    value={this.props.habits.substace}
                                                    onChange={(e) =>
                                                        this.props.handlerHabits("substace", e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </div>
                        <div className="half">
                            <div className="form">
                                <div style={{ width: "15%" }}>
                                    <div className="card__title">
                                        <h5 className="bold-text">Información de alcohol</h5>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">
                                            Consumió alcohol
                                        </span>
                                        <div className="lumber-form__form-group-field">
                                            <label className="radio-btn" >
                                                <input
                                                    className="radio-btn__radio"
                                                    name="alcohol"
                                                    type="radio"
                                                    value={'Si'}
                                                    checked={this.props.habits.alcohol === 'Si'}
                                                    onChange={(e) => {
                                                        this.props.handlerHabits("alcohol", e.target.value);
                                                        this.setState({ alcohol: e.target.value });
                                                    }}
                                                />
                                                <span className="radio-btn__radio-custom" />
                                                <span className="radio-btn__label">{"Sí"}</span>
                                            </label>
                                            <label className="radio-btn" >

                                                <input
                                                    className="radio-btn__radio"
                                                    name="alcohol"
                                                    type="radio"
                                                    value={'No'}
                                                    checked={this.props.habits.alcohol === 'No'}
                                                    onChange={(e) => {
                                                        this.props.handlerHabits("alcohol", e.target.value);
                                                        this.setState({ alcohol: e.target.value });
                                                    }}
                                                />
                                                <span className="radio-btn__radio-custom" />
                                                <span className="radio-btn__label">{"No"}</span>
                                            </label>

                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="form__form-group"
                                    style={{ width: "10%", marginLeft: 15, marginTop: 50 }}
                                >
                                    <span className="form__form-group-label">
                                        En el ultimo año
                                    </span>
                                    <div className="lumber-form__form-group-field">
                                        <Field
                                            name="alcohol-last-year-select"
                                            component={renderSelectField}
                                            options={[
                                                { value: "Si", label: "Si" },
                                                { value: "No", label: "No" },
                                            ]}
                                            value={this.props.habits.alcoholLastYear}
                                            onChange={(e) => {
                                                this.props.handlerHabits("alcoholLastYear", e);
                                            }}
                                        />
                                    </div>
                                </div>
                                {this.props.habits.alcohol === "Si" ? (
                                    <Fragment>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "10%", marginLeft: 15, marginTop: 50 }}
                                        >
                                            <span className="form__form-group-label">Frecuencia</span>
                                            <div className="lumber-form__form-group-field">
                                                <Field
                                                    className="years-select"
                                                    name="frecuency-of-consumption-alcohol"
                                                    component={renderSelectField}
                                                    options={[
                                                        { value: "Diaria", label: "Diaria" },
                                                        { value: "Semanal", label: "Semanal" },
                                                        { value: "Mensual", label: "Mensual" },
                                                    ]}
                                                    value={this.props.habits.frecuencyAlcohol}
                                                    onChange={(e) =>
                                                        this.props.handlerHabits("frecuencyAlcohol", e)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Fragment>
                                ) : null}
                            </div>
                            <div className="form">
                                <div style={{ width: "15%" }}>
                                    <div className="card__title">
                                        <h5 className="bold-text">
                                            Información de Actividades Físicas
                                        </h5>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">
                                            Práctica actividad fisica
                                        </span>
                                        <div className="lumber-form__form-group-field">
                                            <label className="radio-btn" >
                                                <input
                                                    className="radio-btn__radio"
                                                    name="physicalActivity"
                                                    type="radio"
                                                    value={'Si'}
                                                    checked={this.props.habits.physicalActivity === 'Si'}
                                                    onChange={(e) => {
                                                        this.props.handlerHabits("physicalActivity", e.target.value);
                                                        this.setState({ physicalActivity: e.target.value });
                                                    }}
                                                />
                                                <span className="radio-btn__radio-custom" />
                                                <span className="radio-btn__label">{"Sí"}</span>
                                            </label>
                                            <label className="radio-btn" >

                                                <input
                                                    className="radio-btn__radio"
                                                    name="physicalActivity"
                                                    type="radio"
                                                    value={'No'}
                                                    checked={this.props.habits.physicalActivity === 'No'}
                                                    onChange={(e) => {
                                                        this.props.handlerHabits("physicalActivity", e.target.value);
                                                        this.setState({ physicalActivity: e.target.value });
                                                    }}
                                                />
                                                <span className="radio-btn__radio-custom" />
                                                <span className="radio-btn__label">{"No"}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {this.props.habits.physicalActivity === "Si" ? (
                                    <Fragment>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "10%", marginLeft: 15, marginTop: 50 }}
                                        >
                                            <span className="form__form-group-label">Frecuencia</span>
                                            <div className="lumber-form__form-group-field">
                                                <Field
                                                    className="years-select"
                                                    name="frecuency-physical-activity"
                                                    component={renderSelectField}
                                                    options={[
                                                        { value: "Diaria", label: "Diaria" },
                                                        { value: "Semanal", label: "Semanal" },
                                                        { value: "Mensual", label: "Mensual" },
                                                    ]}
                                                    value={this.props.habits.frecuencyPhysicalActivity}
                                                    onChange={(e) =>
                                                        this.props.handlerHabits(
                                                            "frecuencyPhysicalActivity",
                                                            e
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="form__form-group"
                                            style={{ width: "50%", marginLeft: 15, marginTop: 50 }}
                                        >
                                            <span className="form__form-group-label">Cuales?</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="textarea-another-physical-activies"
                                                    component="textarea"
                                                    type="text"
                                                    value={this.props.habits.activities}
                                                    onChange={(e) =>
                                                        this.props.handlerHabits(
                                                            "activities",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Fragment>
                                ) : null}
                            </div>
                            <div className="form">
                                <div className="card__title">
                                    <h5 className="bold-text">Información de Hábitos Nutricionales</h5>
                                </div>
                                <div className="form__form-group-field" >
                                    <textarea
                                        name="textarea-nutricional"
                                        style={{ width: '50%'}}
                                        onChange={(e) => {
                                            this.props.handlerHabits(
                                                "nutricional",
                                                e.target.value
                                            )
                                        }}
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Card>);
    }
}

export default reduxForm({
    form: 'habits_form', // a unique identifier for this form
})(withTranslation('common')(Habits));